import React from 'react';
import { connect } from 'react-redux';
import {  Col, Input, Row, Select } from 'antd';
import { compose } from 'redux';
import Selector from '../../../../../../../components/selector';
import EnhancedModal from '../../../../../../../components/enhanced-modal';
import { GUTTER_MD, GUTTER_SM, GUTTER_XS, MODAL_WIDTH_MD } from '../../../../../../../styles/constants';
import { DataLanguageConsumer } from '../../../../../../../contexts/DataLanguage';
import InfiniteScrollDataTable from '../../../../../../../components/infinite-scroll-data-table';
import { getFilterObjFromViewerObj } from '../../../../../../../utils/filter';
import { getDistinctTempTable, onChangeCaseFunction } from '../../actions';
import { translate } from 'react-i18next';
import _ from 'lodash';
import { createExpressionToQuery } from '../../../utils';

const mapStateToProps = state => ({
    tempTable: state.scenes.dataManager.fileMapping.components.wizard.shared.tempTableName,
    selectDistinctData: state.scenes.dataManager.fileMapping.components.wizard.components.addField.selectDistinctData,
    nameValue:state.scenes.dataManager.fileMapping.components.wizard.components.addField.FunctionFormData.nameValue
})

const mapDispatchToProps = dispatch => ({
    onGetDistinctTempTable:({tempTable, query, filters, pageNum,pageSize,sortByDesc, sortCol}) => dispatch(getDistinctTempTable(tempTable, query,  filters, pageNum,pageSize,sortByDesc, sortCol)),
    onChangeForm: (value) => dispatch(onChangeCaseFunction(value))
})

const CaseCondition = ({
    t,
    value,
    selectFunction,
    selectComponent,
    onChangeForm,
    block,
    onGetDistinctTempTable,
    tempTable,
    selectDistinctData,
    selectOperators,
    conditionsIndex
}) => {

    const [modalFunctionValueVisible, setModalFunctionValueVisible] = React.useState(false)
    const [selectedSeries, setSelectedSeries] = React.useState([])
    const condition = React.useMemo(()=> { return value },[value])
    React.useEffect(()=>{},[condition])
    const blockIndex = React.useMemo(()=> { return block.blockIdx},[block])

    const selectorAvailable = React.useMemo(()=> {
        const {functionName,componentName, values, operator} = value
        switch(functionName){
            case 'Str func':
                return !!componentName && !!operator;
            case 'Replace':
                return !!componentName && !!operator && !!values.replace && !!values.with;
            case 'LPad':
            case 'RPad':
                return !!componentName && !!operator && !!values.pattern;
            case 'Trim':
                return !!componentName && !!operator;
            case 'LTrim':
            case 'RTrim':
                return !!componentName && !!operator && !!values.chars;
            case 'Substr':
                return !!componentName && !!operator && !!values.start && !!values.end;
            default:
                return false;
        }
    },[value])
    

    React.useEffect(()=>{
        if(conditionsIndex > 1){
            onChangeForm({blockIdx:block.blockIdx, logicalOperator: 'AND'})
        }else{
            onChangeForm({blockIdx:block.blockIdx, logicalOperator: ''})
        }
    },[conditionsIndex])

    React.useEffect(()=>{},[value])


    return (
        <Row type="flex" style={{ flexDirection:'column', border:'1px solid #DADADA', padding:10, rowGap:10}}> 
        <Row type='flex'  >    
            <Col style={{marginRight:GUTTER_XS}}>
                <Select
                    style={{width:100}}
                    value={condition.functionName}
                    defaultValue={"Str func"}
                    title={condition.functionName}
                    onChange={(value)=> onChangeForm({blockIdx:block.blockIdx, idx:condition.idx, functionName: value})}
                    >
                    {
                        selectFunction.map((funct) => (
                            <Select.Option key={funct} title={funct} value={funct}>{funct}</Select.Option>
                        ))
                    }
                </Select>
            </Col>
            <Col style={{marginRight:GUTTER_XS}} >
                
                <Select
                    title={condition.componentName}
                    style={{width:130}}
                    value={condition.componentName}
                    onChange={(value) => onChangeForm({blockIdx:blockIndex, idx:condition.idx, componentName:value})}
                    >
                    {selectComponent.map((field) => (
                        <Select.Option
                            key={field}
                            value={field}
                            title={`${field}`}
                            >
                            {field}
                        </Select.Option>
                    ))}
                </Select>
                
            </Col>
            <Col style={{marginRight:GUTTER_XS}}>
                <Select 
                title={condition.operator}
                style={{width:80}}
                value={condition.operator}
                onChange={(value) => onChangeForm({blockIdx:blockIndex, idx:condition.idx, operator:value})}>
                {selectOperators.map((field) => (
                        <Select.Option
                            key={field}
                            value={field}
                            title={`${field}`}
                            >
                            {field}
                        </Select.Option>
                    ))}   
                </Select>    
            </Col>
            <Col style={{marginRight:GUTTER_SM}}>            
                    <Selector
                        style={{width:150, top:0}}
                        value={condition.selectDistinct}
                        onSelect={()=> setModalFunctionValueVisible(true)}
                        onReset={()=> onChangeForm({blockIdx: blockIndex, idx: condition.idx, selectDistinct: null })}
                        disabled={!selectorAvailable}
                        />
                        <EnhancedModal
                            visible={modalFunctionValueVisible}  
                            onCancel={() => setModalFunctionValueVisible(false)}
                            title={t('scenes.dataManager.fileMapping.wizard.addField.functions.case.modal.title')}
                            withDataLanguageSelector
                            width={MODAL_WIDTH_MD}
                            >
                                <DataLanguageConsumer>
                                {dataLanguage => {
                                    //const language = dataLanguage || appLanguage;
                                     return !['IN','NOT IN'].includes(condition.operator) ?
                                        (
                                        <InfiniteScrollDataTable
                                            data={selectDistinctData && selectDistinctData.Data}
                                            rowTotal={selectDistinctData && selectDistinctData.Count}
                                            cols={selectDistinctData && selectDistinctData.Columns}
                                            onRowClick={(value) => {
                                                onChangeForm({blockIdx:blockIndex, idx: condition.idx, selectDistinct: value[Object.keys(value)[0]] })
                                                setModalFunctionValueVisible(false)
                                            }}
                                            onChange={({ filters, pageNum,pageSize,searchText,sortByDesc, sortCol}) => {
                                                onGetDistinctTempTable({
                                                    tempTable,
                                                    query: createExpressionToQuery(condition),
                                                    filters:getFilterObjFromViewerObj(
                                                        selectDistinctData && selectDistinctData.Columns,
                                                        searchText,
                                                        filters
                                                        ), 
                                                pageNum,
                                                pageSize,
                                                sortByDesc, 
                                                sortCol
                                                })
                                            }}
                                            />
                                        ) :
                                        (<InfiniteScrollDataTable
                                        data={selectDistinctData && selectDistinctData.Data}
                                        rowTotal={selectDistinctData && selectDistinctData.Count}
                                        cols={selectDistinctData && selectDistinctData.Columns}
                                        getRowKey={({VALUE}) => VALUE}
                                        rowSelection={{}}
                                        onChange={({ filters, pageNum,pageSize,searchText,sortByDesc, sortCol}) => {
                                            onGetDistinctTempTable({
                                                tempTable,
                                                query: createExpressionToQuery(condition),
                                                filters:getFilterObjFromViewerObj(
                                                    selectDistinctData && selectDistinctData.Columns,
                                                    searchText,
                                                    filters
                                                    ), 
                                            pageNum,
                                            pageSize,
                                            sortByDesc, 
                                            sortCol
                                            })
                                        }}
                                        tableActions={[
                                            {
                                                title:t('scenes.dataManager.fileMapping.wizard.addField.functions.case.modal.addValues'),
                                                onClick:(values, deselect) => {
                                                   onChangeForm({blockIdx:blockIndex, idx: condition.idx, selectDistinct: values.map(e => e.VALUE)});
                                                   setModalFunctionValueVisible(false);
                                                   deselect();           
                                                }
                                            }
                                            ]}
                                        />
                                        )
                                    }       
                                }  
                            </DataLanguageConsumer>
                        </EnhancedModal>             
            </Col>
        </Row>
            {
            (condition.functionName === 'LPad' || condition.functionName === 'RPad') &&
            <Row type="flex" style={{alignItems:'center', gap:GUTTER_XS}}>
                <span>{t('scenes.dataManager.fileMapping.wizard.addField.functions.case.label.pattern')}</span>
                <Input style={{width: 100}} 
                    value={!!_.some(condition.values.pattern) ? condition.values.pattern: ''}
                    onChange={({target}) => 
                        onChangeForm({
                            blockIdx:blockIndex,
                            idx:condition.idx, 
                            value: {pattern: target.value} 
                            })
                        }
                    />
            </Row>
            }
            {
            condition.functionName === 'Replace' && 
            <Row type="flex" style={{ alignItems:'center', gap:GUTTER_MD}}>
                <Col>
                    <Row type="flex" style={{ alignItems:'center', gap:GUTTER_XS}}>
                        <span>{t('scenes.dataManager.fileMapping.wizard.addField.functions.case.label.replace')}</span>                       
                        <Input style={{width: 100}} 
                            value={_.some(condition.values.replace) ? condition.values.replace : ''}
                            onChange={({target}) => onChangeForm({
                                blockIdx:blockIndex,
                                idx:condition.idx,
                                values:{replace:target.value}
                            })}
                        />   
                    </Row>
                </Col>
                <Col>
                    <Row type="flex" style={{  alignItems:'center', gap:GUTTER_XS}}>
                        <span>{t('scenes.dataManager.fileMapping.wizard.addField.functions.case.label.with')}</span>
                        <Col >
                            <Input style={{width: 100}}
                                value={_.some(condition.values.with) ? condition.values.with : ''}
                                onChange={({target}) => onChangeForm({
                                    blockIdx:blockIndex,
                                    idx:condition.idx,
                                    values:{with:target.value}
                                })}
                                />
                        </Col>
                    </Row>
                </Col>
            </Row>
            }
            {
            condition.functionName === 'Substr' && 
            <Row type="flex"  style={{ alignItems:'center', gap:GUTTER_MD}}>
                <Col >
                    <Row type="flex" style={{alignItems:'center',gap:GUTTER_XS}}>
                        <span>{t('scenes.dataManager.fileMapping.wizard.addField.functions.case.label.start')}</span>                            
                        <Input style={{width: 100}} 
                        value={_.some(condition.values.start) ?  condition.values.start : ''}
                        onChange={({target})=> onChangeForm({
                            blockIdx:blockIndex,
                            idx:condition.idx,
                            values:{ start: target.value }
                        })}
                        />
                    </Row>
                </Col>
                <Col >
                    <Row type="flex" style={{alignItems:'center',gap:GUTTER_XS }}>
                        <span>{t('scenes.dataManager.fileMapping.wizard.addField.functions.case.label.end')}</span>
                        <Input style={{width: 100}}
                        value={_.some(condition.values.end) ?  condition.values.end : ''}
                        onChange={({target})=> onChangeForm({
                            blockIdx:blockIndex,
                            idx:value.idx,
                            values:{end:target.value}
                        })}
                        />
                    </Row>
                </Col>
            </Row>
            }
            {        
            (condition.functionName === 'Trim' || condition.functionName === 'LTrim' || condition.functionName === 'RTrim' ) &&
            <Row type="flex" style={{ alignItems:'center', gap:GUTTER_XS}}>
            <span>{t('scenes.dataManager.fileMapping.wizard.addField.functions.case.label.charsToTrim')}</span>
            <Input style={{width: 100}} 
                value={_.some(condition.values.chars) ? condition.values.chars : ''}
                onChange={({target}) => onChangeForm({
                    blockIdx:blockIndex,
                    idx:condition.idx,
                    values:{chars: target.value}
                })}
            />
            </Row>
            }
        </Row>
    )
}

export default compose(
    translate(),
    connect(mapStateToProps,mapDispatchToProps)
)(CaseCondition);